import React from 'react';
import { useIntl } from 'ha/i18n';
import { makeStyles } from '@material-ui/core';
import Button, { ButtonProps } from '@material-ui/core/Button';
import AddAlertIcon from '@material-ui/icons/AddAlert';

import units from 'ha/theme/units';
import Track from 'ha/components/track/SmartTrack';
import NoSSR from 'ha/components/NoSSR';

export interface Props {
  isDisabled: boolean;
  hasAlert: boolean;
  isAuthenticated: boolean;
  isMobile: boolean;
  color?: ButtonProps['color'];
  variant?: ButtonProps['variant'];
  getDynamicData: () => object;
  onClick?: (options?: object) => void;
}

const useStyles = makeStyles(t => ({
  icon: {
    marginRight: t.spacing(1),
    fontSize: units.rem(1.2),
  },
}));

export const SearchAlertButton: React.FC<Props> = ({
  isMobile,
  isDisabled,
  hasAlert,
  getDynamicData,
  color = 'secondary',
  variant = 'outlined',
  onClick,
}) => {
  const classes = useStyles();
  const { T } = useIntl();

  const handleClick = React.useCallback(() => {
    if (onClick) {
      onClick({
        title: T('search_alert_create_confirmation_title'),
        description: T('search_alert_create_confirmation_text'),
        hideBenefits: true,
        hideLogo: true,
      });
    }
  }, [onClick, T]);

  return (
    <NoSSR>
      <Track
        name="Clicked create search alert"
        type="button"
        getDynamicData={getDynamicData}
      >
        <Button
          color={color}
          variant={variant}
          onClick={handleClick}
          disabled={isDisabled}
          size={isMobile ? 'small' : undefined}
          data-test-locator="Search Alert Button"
        >
          <AddAlertIcon className={classes.icon} />
          {hasAlert
            ? T('search_alert_update_button')
            : T('search_alert_create_button')}
        </Button>
      </Track>
    </NoSSR>
  );
};

export default SearchAlertButton;
